import {EnvironmentConfiguration} from './configuration';

export const environmentConfiguration: EnvironmentConfiguration = {
    environment: 'fer',
    apiRoot: 'https://apply.zvne.fer.hr/nowcasting-server',
    geoserverRoot: 'https://apply.zvne.fer.hr/geoserver/wms',
    geoserverLayerPrefix: 'pg-fer',
    keycloakUrl: 'https://applygit.zvne.fer.hr/keycloak/auth',
    keycloakRealm: 'nowcasting',
    keycloakClientId: 'web-client'
};
